var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "list-group-item" },
    [
      _c("b-row", [
        _c(
          "div",
          { staticClass: "col-12 mb-2" },
          [_c("b-skeleton", { staticClass: "ml-0 mr-2" })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("b-skeleton", {
              staticClass: "mr-2",
              attrs: { height: "5rem" },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }